<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column align="center" :label="getType(typ)">
        <el-table-column
          prop="rank"
          align="center"
          label="排名"
        >
          <template v-slot:default="scope">{{ scope.$index+1 }}</template>
        </el-table-column>
        <el-table-column
          prop="uid"
          align="center"
          label="玩家UID"
        >
          <template v-slot:default="scope">
            <a href="javascript:;" style="color: #0e6cff;text-decoration:underline;text-underline: #1c84c6;" @click="gotoreward(scope.row.uid)"> {{ scope.row.uid }}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="count"
          align="center"
          label="转动次数"
          :formatter="scientificFormat"
        />
        <el-table-column
          prop="num"
          align="center"
          :label="title"
          :formatter="scientificFormat"
        />
        <el-table-column
          prop="rate"
          align="center"
          label="触发概率"
          :formatter="scientificFormat"
        />
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'TableData',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: () => ''
    },
    typ: {
      type: Number,
      default: () => 1
    },
    pay: {
      type: Number,
      default: () => 0
    },
    ftyp: {
      type: String,
      default: () => 'levelId'
    }
  },
  methods: {
    getType(type) {
      if (type === 1) {
        return '打排行榜'
      }
      return '偷排行榜'
    },
    scientificFormat(row, col, value) {
      if (value === 0) {
        return 0
      } else {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    gotoreward(uid) {
      this.$router.push({ name: 'User', query: { uid: uid }})
    }
  }
}
</script>

<style scoped>

</style>
